/*
 * @Author: LiuMouLiang
 * @Date:   2022-03-08 16:02:23
 * 域名配置
 */
/* eslint-disable */
"use strict";
import {
    _encode,
} from 'tools';
import requireLocalEnv from 'build/requireLocalEnv'; //读取本地环境的变量
export const process_env = process.env || {};

/* 全局环境 */
// export const IS_RELEASE = process_env.BUILD_ENV === 'online'
export const IS_RELEASE = process_env.NODE_ENV === 'production'; //是否是正式环境
export const IS_DEVELOPMENT = process_env.NODE_ENV === 'development';
export const IS_LOCAL = location.href.includes('8797');
export const VERSION = process_env.VERSION || '1.0.0';

/* mock环境 */
let IS_MOCK = false;
let IS_KJMOCK = false;
let LOCAL_ENV = {};
if(IS_DEVELOPMENT){
    LOCAL_ENV = requireLocalEnv && requireLocalEnv() || {};
}

if(process_env.isMock){
    IS_MOCK = LOCAL_ENV.env_Mock || IS_MOCK || false;
    IS_KJMOCK = LOCAL_ENV.env_Mock_KJ || IS_KJMOCK || false;
}
export const MockURL = "/mock/"
export const env_isTrace = LOCAL_ENV.env_isTrace || false;
export const env_stopSpecialIntercept = IS_DEVELOPMENT ? !!LOCAL_ENV.env_stopSpecialIntercept : false; // 停止特殊拦截
export const env_stopPageRecord = IS_LOCAL; // 是否记录页面数据
export {
    IS_MOCK,
    IS_KJMOCK,
    LOCAL_ENV,
}

/* 地址 */
const WEBVIEWPAGE = 'https://j.winbaoxian.com/webview/page'
const DEV_DOMAIN_URL = 'https://dev.wyins.net.cn:8797';
const PDF_URL = 'https://res.wyins.net/autoUpload/pdfjs/pdfjs-4.1.392/web/viewer.html';
let OSS_URL = "https://third-api.wyins.net"; //OSS

//获取穿越链接
export const getUrl_WEBVIEWPAGE = function(url){
    return WEBVIEWPAGE + '?url=' + _encode(url);
};
/* 签约项目 */
let SIGN_DOMAIN = "https://broker-2a.wyins.net"; //签约域名
let SIGN_IDENTITY_URLs = {
    QRCODE: 'https://res.wyins.net/autoUpload/common/14809e37-aa73-4d30-8f81-e88a2e1f33f7.png',
};

const BASE_API = process_env.BASE_API;
const PERSONAL_INSURANCE_URL = process_env.PERSONAL_INSURANCE_URL;
const DOMAIN = process_env.DOMAIN;
// const BASE_API_KJ = IS_KJMOCK ? `${DEV_DOMAIN_URL}/mock` :  process_env.BASE_API_KJ; //登录后测试环境就退出了
const KJ_PAGE_URL = IS_LOCAL ? DEV_DOMAIN_URL : process_env.KJ_PAGE_URL;
const ROUTE_URL_PC = IS_LOCAL ? '/' : '/insurance-group-pc-new/'; //pc路径

if (IS_DEVELOPMENT) {
    OSS_URL = "https://third-api.wyins.net.cn";
    SIGN_DOMAIN = "https://broker-2a.wyins.net.cn";
    SIGN_IDENTITY_URLs['QRCODE'] = `https://res.wyins.net/autoUpload/common/3e7b6967-6ab3-4dad-84aa-fe8141f347e0.png`;
};

SIGN_IDENTITY_URLs['APP'] = `${SIGN_DOMAIN}/sign-identity.html`, //app内跳转
SIGN_IDENTITY_URLs['PASS'] = getUrl_WEBVIEWPAGE(SIGN_IDENTITY_URLs.APP); //穿越链接

export {
    BASE_API,
    PERSONAL_INSURANCE_URL,
    OSS_URL,
    PDF_URL, //?file=url
    DOMAIN,
    // BASE_API_KJ,
    KJ_PAGE_URL,
    ROUTE_URL_PC,
    //签约项目
    SIGN_DOMAIN,
    SIGN_IDENTITY_URLs,
};



// WEBPACK FOOTER //
// ./src/libs/host.js